module.exports = __webpack_public_path__ + "static/media/car-full.7b0eb3bc.webp";